import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect, SelectOption } from '@netiva/classifieds-ui';

import { SdkParams } from '@/store/sdk';
import { usePlatforms } from '../usePlatforms';

export const CommonFormControls = () => {
  const { t } = useTranslation();

  const { platforms, isLoading } = usePlatforms();

  const platformOptions = useMemo<SelectOption[]>(
    () => platforms.map((p) => ({ label: p.name, value: p.key })),
    [platforms]
  );
  const languageOptions = useMemo<SelectOption[]>(
    () => [
      { label: '-', value: '' },
      { label: t('languages.de'), value: 'de' },
      { label: t('languages.fr'), value: 'fr' },
    ],
    [t]
  );

  return (
    <>
      <FormSelect<SdkParams>
        label={t('sdk.platform.label')}
        description={t('sdk.platform.helpText')}
        name="platform"
        options={platformOptions}
        isRequired
        isLoading={isLoading}
      />
      <FormSelect<SdkParams>
        label={t('sdk.language.label')}
        description={t('sdk.language.helpText')}
        name="language"
        options={languageOptions}
      />
    </>
  );
};
